<script lang="ts">
  import { Fieldset, Properties } from '@factry/components'
  import type { AssetEvent } from '../types'

  export let event: AssetEvent | undefined

  let leftProperties: Record<string, unknown> = {}
  let rightProperties: Record<string, unknown> = {}

  function splitProperties (event: AssetEvent | undefined): void {
    if (!event) return

    leftProperties = {
      Material: event?.material || 'Material Definition',
      Recipe: event.recipe,
      Length: event?.length || '12.2 m',
      'Wall Thickness': event?.wall_thickness || '25.4 mm',
      'Design Life': event?.design_life || '30 years',
    }
    const excludedKeys = ['material', 'recipe', 'length', 'wall_thickness', 'design_life', 'co2']
    rightProperties = Object.fromEntries(
      Object.entries(event).filter(([key]) => !excludedKeys.includes(key))
    )
  }

  $: splitProperties(event)
</script>

<style lang="scss">
  @import '../utils/base';

  .columns {
    justify-content: center;
  }

  .column.is-6 {
    max-width: 700px;

    :global(.fieldset) {
      background-color: $white;
      border-radius: $radius;
      border: 1px solid $border;
      padding: $spacing !important;

      :global(legend) {
        text-shadow: 2px 2px 2px white,
          -2px 2px 2px white,
          2px -2px 2px white,
          -2px -2px 2px white !important;
      }

      :global(.property-field:not(:last-child)) {
        border-bottom: 1px solid $grey-lightest;
        margin-bottom: $spacing * 0.25;
        padding-bottom: $spacing * 0.25;
      }

      @include from($tablet) {
        :global(.field-label) {
          flex-grow: 5; // Make the label and value the same size so the text is nice and center
          text-align: left;

          :global(.label) {
            font-weight: normal;
          }
        }
      }
      @include from($tablet) {
        :global(.field-body) {
          flex-grow: 5;
          text-align: right;

          :global(.control) {
            justify-content: end;
          }
        }
      }
    }
  }
</style>

<div class="columns">
  <div class="column is-6">
    <Fieldset label="Technical specification" hasFloatingLegend>
      <Properties
        horizontal
        edit={false}
        properties={leftProperties}
        allowNew={false}
      />
    </Fieldset>
  </div>

  <div class="column is-6">
    <Fieldset label="Production data" hasFloatingLegend>
      <Properties
        horizontal
        edit={false}
        properties={rightProperties}
        allowNew={false}
      />
    </Fieldset>
  </div>
</div>
